// Copyright (C) Microsoft Corporation. All rights reserved.

import { initializeMobileNavigation } from './LeftNavigation';

$(function () {
	initializeMobileNavigation();
});
